import { getEnv, getEnvMode } from 'complex-utils'
import setting from '../setting'

export const getCurrentUrl = function(type: string, real?: boolean) {
  const realEnv = getEnv('real')
  const prop = getEnvMode('data') || 'default'
  let currentUrl
  if (setting.proxy.run && realEnv === 'development' && !real) {
    currentUrl = setting.proxy.buildProp(type, prop) + '/'
  } else {
    currentUrl = setting.proxy.url[type][prop]
    if (!currentUrl) {
      currentUrl = setting.proxy.url[type].default
    }
  }
  return currentUrl
}
